import Loadable from 'react-loadable';

export const StatusUpdatesView = Loadable({
  loader: () => import(/* webpackChunkName: "StatusUpdatesView" */ './StatusUpdates'),
  loading: () => null,
});
